/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import "es6-shim";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/es/integration/react";
import { ApolloProvider } from "@apollo/client";
import { Auth0Provider } from "@auth0/auth0-react";

import "./index.css";
import { unregister } from "./registerServiceWorker";
import App from "./containers/App";
import { persistor, store } from "store";
import { UpduoApolloClient } from "./config/UpduoApolloClient";

const onBeforeLift = () => {
  // take some action before the gate lifts
};

// The main web app entry point
ReactDOM.render(
  <Provider store={store}>
    <PersistGate onBeforeLift={onBeforeLift} persistor={persistor}>
      <Auth0Provider
        domain={process.env.REACT_APP_AUTH0_DOMAIN || ""}
        clientId={process.env.REACT_APP_AUTH0_CLIENT_ID || ""}
        redirectUri={window.location.origin}
      >
        <ApolloProvider client={UpduoApolloClient}>
          <App />
        </ApolloProvider>
      </Auth0Provider>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);
unregister();
